import LoadingScreen from 'components/LoadingScreen';
import React from 'react';
import { Button } from 'reactstrap';

import BPAFindingExternalAccessPermissions from './BPAFindingExternalAccessPermissions';
import BPAFindingIAMPermissions from './BPAFindingIAMPermissions';
import { BPAFindingPermissionsStatus } from '../../types/bpaFindings.types';

interface Props {
  error: string;
  isLoading: boolean;
  onRetry: () => void;
  permissions?: Record<string, unknown> | null;
  service?: string | null;
  status: BPAFindingPermissionsStatus;
}

const isNonEmptyObject = (
  value?: Record<string, unknown> | null,
): value is Record<string, unknown> =>
  Boolean(
    value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.keys(value).length > 0,
  );

const renderPermissions = (
  permissions: Record<string, unknown>,
  service?: string | null,
) => {
  const normalizedService = service?.trim().toLowerCase();
  if (normalizedService === 'iam') {
    return <BPAFindingIAMPermissions permissions={permissions} />;
  }
  if (normalizedService === 'external_access') {
    return <BPAFindingExternalAccessPermissions permissions={permissions} />;
  }

  return (
    <pre className="bpa-finding-permissions-json">
      {JSON.stringify(permissions, null, 2)}
    </pre>
  );
};

const BPAFindingPermissionsTab: React.FC<Props> = ({
  error,
  isLoading,
  onRetry,
  permissions,
  service,
  status,
}) => {
  if (error) {
    return (
      <div className="alert alert-danger d-flex align-items-center justify-content-between mb-0">
        <span>{error}</span>
        <Button color="danger" outline size="sm" onClick={onRetry}>
          Retry
        </Button>
      </div>
    );
  }

  if (isLoading || status === 'refresh_required') {
    return <LoadingScreen message="Loading permissions..." height={180} />;
  }

  if (!isNonEmptyObject(permissions)) {
    return (
      <div className="alert alert-info mb-0">
        No permission details are available for this finding.
      </div>
    );
  }

  return <>{renderPermissions(permissions, service)}</>;
};

export default BPAFindingPermissionsTab;
